import { colors, fonts } from '../../theme';

const row = {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: 1.25,
  px: 1.5,
  py: 0.75,
  border: 0,
  backgroundColor: 'transparent',
  textAlign: 'left',
  cursor: 'pointer',
};

// Empty round on the right of a suggestion, like the app.
const round = {
  width: 16,
  height: 16,
  flexShrink: 0,
  borderRadius: '50%',
  border: '1.5px solid #555555',
  boxSizing: 'border-box',
};

const styles = {
  round,
  // Above the field, as wide as the form: it never leaves the panel, even on a phone.
  root: {
    position: 'absolute',
    left: 12,
    right: 12,
    bottom: '100%',
    mb: 0.5,
    py: 0.5,
    maxHeight: 220,
    overflowY: 'auto',
    backgroundColor: colors.surface,
    backgroundImage: 'none',
    border: `1px solid ${colors.border}`,
    borderRadius: '10px',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.5)',
    zIndex: 2,
  },
  row,
  rowActive: {
    ...row,
    backgroundColor: colors.hoverItem,
  },
  avatar: {
    width: 28,
    height: 28,
    flexShrink: 0,
  },
  texts: {
    flexGrow: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 0.125,
  },
  username: {
    fontFamily: fonts.text,
    fontSize: 13,
    fontWeight: 600,
    color: colors.text,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  match: {
    color: colors.mention,
  },
  handle: {
    fontFamily: fonts.text,
    fontSize: 11.5,
    color: colors.textSubtle,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  // Same size as the round it replaces.
  check: {
    width: 18,
    height: 18,
    m: '-1px',
    flexShrink: 0,
    color: colors.mention,
  },
  loading: {
    py: 1,
    display: 'flex',
    justifyContent: 'center',
  },
  spinner: {
    color: colors.textSubtle,
  },
};

export default styles;
